import { useCallback, useEffect, useRef, useState } from 'react'
import NumberPicker from './NumberPicker'
// import SoldPicker from './SoldPicker'
import SearchInput from './SearchInput'
import SoldPicker from './SoldPicker'

export interface ITileProps {
	resetQuery?: () => void
	close: () => void
	show: boolean
	hasFilters: boolean
	query: any
	segment: string
	dataAutocomplete: any
	setQuery: (query: any) => void
}

const Filter = ({ segment, resetQuery, dataAutocomplete, close, show, hasFilters, query, setQuery }: ITileProps) => {
	const escFunction = useCallback((event: any) => {
	  if (event.key === "Escape") {
		close()
	  }
	}, []);

	useEffect(() => {
	  document.addEventListener("keydown", escFunction, false);

	  return () => {
		document.removeEventListener("keydown", escFunction, false);
	  };
	}, [escFunction]);

	const updateQuery = (query) => {
		setQuery({...query, page: 1	})
	}


	return (
		<div className={["listing-filter-scrim", show ? 'listing-filter-active' : ''].join(' ')} onClick={close}>
			<div className="listing-filter" onClick={(e) => e.stopPropagation()}>
				<div className="listing-title">
					<h5>Filters</h5>
					<button onClick={close}>
						<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fillRule="evenodd" clipRule="evenodd" d="M4.41083 4.91075C4.73626 4.58531 5.2639 4.58531 5.58934 4.91075L10.0001 9.32149L14.4108 4.91075C14.7363 4.58531 15.2639 4.58531 15.5893 4.91075C15.9148 5.23619 15.9148 5.76382 15.5893 6.08926L11.1786 10.5L15.5893 14.9108C15.9148 15.2362 15.9148 15.7638 15.5893 16.0893C15.2639 16.4147 14.7363 16.4147 14.4108 16.0893L10.0001 11.6785L5.58934 16.0893C5.2639 16.4147 4.73626 16.4147 4.41083 16.0893C4.08539 15.7638 4.08539 15.2362 4.41083 14.9108L8.82157 10.5L4.41083 6.08926C4.08539 5.76382 4.08539 5.23619 4.41083 4.91075Z" fill="#214359"/>
						</svg>
					</button>
				</div>
				<div className="listing-filter-options">
					<div className='search-filter'>
						<label htmlFor="filter-search">Search</label>
						<SearchInput
							icon={
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fillRule="evenodd" clipRule="evenodd" d="M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8487 17.3729 13.551 16.3199 14.9056L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14.9056 16.3199C13.551 17.3729 11.8487 18 10 18C5.58172 18 2 14.4183 2 10Z" fill="#86C0C7"/>
								</svg>
							}
							onChange={(e) => {
								setQuery({search: e.target.value, agent: '', page: 1})}
							}
							clearResults={() => {
								setQuery({search: '', agent: '', page: 1})
							}}
							setQuery={setQuery}
							autocomplete={dataAutocomplete}
							value={query?.agent || query?.search}
						/>
					</div>
					<hr />
					{(segment == 'Sell' || segment == 'Leased') &&
						<>
							<div className='search-filter'>
								{(segment == 'Sell') &&
									<label htmlFor="filter-beds">Sold date</label>
								}
								{(segment == 'Leased') &&
									<label htmlFor="filter-beds">Leased date</label>
								}
								<SoldPicker
									active={query?.showAllDates}
									setActive={(val) => updateQuery({showAllDates: val})}
								/>
							</div>
							<hr />
						</>
					}
					{segment !== 'Commercial' ?
						<>
							<div className='search-filter'>
								<label htmlFor="filter-beds">Bedrooms</label>
								<NumberPicker
									active={query?.beds}
									setActive={(val) => updateQuery({beds: val})}
									exact={query?.bedsexact}
									setExact={(val) => updateQuery({bedsexact: val})}
								/>
							</div>
							<hr />
							<div className='search-filter'>
								<label htmlFor="filter-beds">Bathrooms</label>
								<NumberPicker
									active={query?.baths}
									setActive={(val) => updateQuery({baths: val})}
									exact={query?.bathsexact}
									setExact={(val) => updateQuery({bathsexact: val})}
								/>
							</div>
							<hr />
						</>
					:
						<></>
					}
							<div className='search-filter'>
								<label htmlFor="filter-beds">Car Spaces</label>
								<NumberPicker
									active={query?.cars}
									setActive={(val) => updateQuery({cars: val})}
									exact={query?.carsexact}
									setExact={(val) => updateQuery({carsexact: val})}
								/>
							</div>
							<hr />
					{segment !== 'Commercial' ?
						<>
							<div className='search-filter'>
								<label htmlFor="property-type">Property type</label>
								<select
									className='form-control custom-select'
									name="property-type"
									value={query?.propertyType}
									id="property-type"
									onChange={(e) => updateQuery({propertyType: e.target.value})}
								>
									<option value="All property types">All property types</option>
									<option value="Apartment">Apartment</option>
									<option value="House">House</option>
									<option value="Townhouse/Semi">Townhouse/Semi</option>
									{segment !== 'Rent' ?
										<option value="Land/Development Site">Land/Development Site</option>
									: null}
								</select>
							</div>
							<hr />
						</>
					:
						<>
							<div className='search-filter'>
								<label htmlFor="property-type">Property type</label>
								<select
									className='form-control custom-select'
									name="property-type"
									value={query?.propertyType || 'Commercial'}
									id="property-type"
									onChange={(e) => updateQuery({propertyType: e.target.value})}
								>
									<option value="Commercial">Commercial</option>
								</select>
							</div>
							<hr />
						</>
					}
					{(segment == 'Leased' || segment == 'Rent') ?
						<div className='search-filter'>
							<label>Price range</label>
							<div className='search-filter-price'>
								<div>
									<small>Min</small>
									<select
										className='form-control custom-select'
										name="min-price"
										value={query?.minPrice}
										id="min-price"
										onChange={(e) => updateQuery({minPrice: e.target.value})}
									>
										<option value="">$ Min PW</option>
										<option value="$150pw">$150pw</option>
										<option value="$200pw">$200pw</option>
										<option value="$250pw">$250pw</option>
										<option value="$300pw">$300pw</option>
										<option value="$350pw">$350pw</option>
										<option value="$400pw">$400pw</option>
										<option value="$450pw">$450pw</option>
										<option value="$500pw">$500pw</option>
										<option value="$550pw">$550pw</option>
										<option value="$600pw">$600pw</option>
										<option value="$650pw">$650pw</option>
										<option value="$700pw">$700pw</option>
										<option value="$750pw">$750pw</option>
										<option value="$800pw">$800pw</option>
										<option value="$850pw">$850pw</option>
										<option value="$900pw">$900pw</option>
										<option value="$950pw">$950pw</option>
										<option value="$1,000pw">$1,000pw</option>
										<option value="$1,100pw">$1,100pw</option>
										<option value="$1,200pw">$1,200pw</option>
										<option value="$1,300pw">$1,300pw</option>
										<option value="$1,400pw">$1,400pw</option>
										<option value="$1,500pw">$1,500pw</option>
										<option value="$1,600pw">$1,600pw</option>
										<option value="$1,700pw">$1,700pw</option>
										<option value="$1,800pw">$1,800pw</option>
										<option value="$1,900pw">$1,900pw</option>
										<option value="$2,000pw">$2,000pw</option>
										<option value="$2,500pw">$2,500pw</option>
										<option value="$3,000pw">$3,000pw</option>
										<option value="$3,500pw">$3,500pw</option>
										<option value="$4,000pw">$4,000pw</option>
										<option value="$4,500pw">$4,500pw</option>
										<option value="$5,000pw">$5,000pw</option>
									</select>
								</div>
								<div>
									<small>Max</small>
									<select
										className='form-control custom-select'
										name="max-price"
										value={query?.maxPrice}
										id="max-price"
										onChange={(e) => updateQuery({maxPrice: e.target.value})}
									>
										<option value="">$ Max PW</option>
										<option value="$150pw">$150pw</option>
										<option value="$200pw">$200pw</option>
										<option value="$250pw">$250pw</option>
										<option value="$300pw">$300pw</option>
										<option value="$350pw">$350pw</option>
										<option value="$400pw">$400pw</option>
										<option value="$450pw">$450pw</option>
										<option value="$500pw">$500pw</option>
										<option value="$550pw">$550pw</option>
										<option value="$600pw">$600pw</option>
										<option value="$650pw">$650pw</option>
										<option value="$700pw">$700pw</option>
										<option value="$750pw">$750pw</option>
										<option value="$800pw">$800pw</option>
										<option value="$850pw">$850pw</option>
										<option value="$900pw">$900pw</option>
										<option value="$950pw">$950pw</option>
										<option value="$1,000pw">$1,000pw</option>
										<option value="$1,100pw">$1,100pw</option>
										<option value="$1,200pw">$1,200pw</option>
										<option value="$1,300pw">$1,300pw</option>
										<option value="$1,400pw">$1,400pw</option>
										<option value="$1,500pw">$1,500pw</option>
										<option value="$1,600pw">$1,600pw</option>
										<option value="$1,700pw">$1,700pw</option>
										<option value="$1,800pw">$1,800pw</option>
										<option value="$1,900pw">$1,900pw</option>
										<option value="$2,000pw">$2,000pw</option>
										<option value="$2,500pw">$2,500pw</option>
										<option value="$3,000pw">$3,000pw</option>
										<option value="$3,500pw">$3,500pw</option>
										<option value="$4,000pw">$4,000pw</option>
										<option value="$4,500pw">$4,500pw</option>
										<option value="$5,000pw">$5,000pw</option>
									</select>
								</div>
							</div>
						</div>
					:
						<div className='search-filter'>
							<label>Price range</label>
							<div className='search-filter-price'>
								<div>
									<small>Min</small>
									<select
										className='form-control custom-select'
										name="min-price"
										value={query?.minPrice}
										id="min-price"
										onChange={(e) => updateQuery({minPrice: e.target.value})}
									>
										<option value="">$ Minimum</option>
										<option value="$300,000">$300,000</option>
										<option value="$400,000">$400,000</option>
										<option value="$500,000">$500,000</option>
										<option value="$600,000">$600,000</option>
										<option value="$700,000">$700,000</option>
										<option value="$800,000">$800,000</option>
										<option value="$900,000">$900,000</option>
										<option value="$1,000,000">$1,000,000</option>
										<option value="$1,500,000">$1,500,000</option>
										<option value="$2,000,000">$2,000,000</option>
										<option value="$3,000,000">$3,000,000</option>
										<option value="$4,000,000">$4,000,000</option>
										<option value="$5,000,000">$5,000,000</option>
									</select>
								</div>
								<div>
									<small>Max</small>
									<select
										className='form-control custom-select'
										name="max-price"
										value={query?.maxPrice}
										id="max-price"
										onChange={(e) => updateQuery({maxPrice: e.target.value})}
									>
										<option value="">$ Maximum</option>
										<option value="$300,000">$300,000</option>
										<option value="$400,000">$400,000</option>
										<option value="$500,000">$500,000</option>
										<option value="$600,000">$600,000</option>
										<option value="$700,000">$700,000</option>
										<option value="$800,000">$800,000</option>
										<option value="$900,000">$900,000</option>
										<option value="$1,000,000">$1,000,000</option>
										<option value="$1,500,000">$1,500,000</option>
										<option value="$2,000,000">$2,000,000</option>
										<option value="$3,000,000">$3,000,000</option>
										<option value="$4,000,000">$4,000,000</option>
										<option value="$5,000,000">$5,000,000</option>
										<option value="Over $5M">Over $5M</option>
									</select>
								</div>
							</div>
						</div>
					}
				</div>
				<div className="listing-filter-actions">
					<button onClick={() => resetQuery()} className='btn btn-link' disabled={!hasFilters}>Reset</button>
					<button onClick={close} className='btn brand accent'>View results</button>
				</div>
			</div>
		</div>
	)
}

export default Filter
